module.exports = __webpack_public_path__ + "static/OUATIB-a26c6d76e2992a3c98e6aecf75ff4950.png";